export const BRAND_NAME = "Bicycle Parts Direct";
export const BRAND_LOGO = "/bicycle-parts-direct-logo.png";
